export function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function getSubdomain() {
  return location.host.split(".")[0];
}

export function validEmail(email) {
  return /^\S+@\S+\.\S+$/.test(email);
}
